"use strict";

var React = require("react");

var _require = require('jss'),
    create = _require.create;

var _require2 = require("react-jss"),
    JssProvider = _require2.JssProvider,
    SheetsRegistry = _require2.SheetsRegistry,
    ThemeProvider = _require2.ThemeProvider;

var configure = require('./.cache/jss.js');

var jss = configure(create());
var sheets = new SheetsRegistry(); // remove the JSS style tag generated on the server to avoid conflicts with the one added on the client

exports.onInitialClientRender = function () {
  var ssStyles = window.document.getElementById("server-side-jss");
  ssStyles && ssStyles.parentNode.removeChild(ssStyles);
}; // eslint-disable-next-line react/prop-types


exports.wrapRootElement = function (_ref, _ref2) {
  var element = _ref.element;
  var _ref2$theme = _ref2.theme,
      theme = _ref2$theme === void 0 ? {} : _ref2$theme;
  return React.createElement(JssProvider, {
    jss: jss,
    registry: sheets
  }, React.createElement(ThemeProvider, {
    theme: theme
  }, element));
};